import axios from 'axios';
import { GET_AREA_UPDATING_TERRITORY_API_URL, GET_REGION_UPDATING_OPTIC_API_URL, GET_STATISTICS_SUBWAY_CANTON_API_URL, GET_STATISTICS_SUBWAY_CITY_API_URL } from '../Optics/OpticApiConfig';

// // загрузка округов
// export async function fetchCantonData() {
//     try {
//       const token = localStorage.getItem('token');
//       const resultCanton = await axios.get(GET_CANTON_API_URL,{
//         headers:{
//           'Authorization': `Bearer ${token}` 
//         }
//       });
//       return resultCanton.data;
//     } catch (error) {
//      // console.error("Error fetching data:", error);
//       return null;
//     }
//   }
  
// export async function loadingCanton(setCanton) {
//     const cantonData = await fetchCantonData();
//     if (cantonData) {
//       setCanton(cantonData);
//     }
//   }

// // загрузка регионов
// export async function loadingRegionsData(canton) {
 
 
//     try {
//       const token = localStorage.getItem('token');
//       const resultRegions = await axios.get(`${GET_REGION_API_URL}?canton=${canton}`,{
//         headers:{
//           'Authorization': `Bearer ${token}` 
//         }
//       });
//       return resultRegions.data;
//     } catch (error) {
//      // console.error("Error fetching regions data:", error);
//       return null;
//     }
// }

// // загрузка веток    
// export async function loadingAreaData(region) {
//     try {
//       const token = localStorage.getItem('token');
//       const resultArea = await axios.get(`${GET_AREA_API_URL}?region=${region}`, {
//         headers:{
//           'Authorization': `Bearer ${token}` 
//         }
//       });
//       return resultArea.data;
//     } catch (error) {
//       //console.error("Error fetching Area data:", error);
//       return null;
//     }
// }

// // загрузка городов
// export async function fetchCityData() {
//   try {

//     const token = localStorage.getItem('token');

//     const resultCity = await axios.get(GET_CITY_API_URL,{
//       headers:{
//         'Authorization': `Bearer ${token}` 
//       }
//     });
//     return resultCity.data;
//   } catch (error) {
//    // console.error("Error fetching resultCity:", error);2
//     return null;
//   }
// }

// export async function loadingCity(setCity) {
//   const cityData = await fetchCityData();
//    if (cityData) {
//      setCity(cityData);
//    }
// }

// Загрузка оптик по регионно для актуализации оптики
export const SearchRegionOptic = async (region, setOptics, setHouses, setError) => {

    if (!region || region.trim() === '') {
        return; 
      }

  try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${GET_REGION_UPDATING_OPTIC_API_URL}?region=${region}`, {
          headers: {
              'Authorization': `Bearer ${token}`
          }
      });
      const { result, houses } = response.data;
      setOptics(result);
      setHouses(houses);

      setError('');
  } catch (error) {
      setError(error.response?.data.message || 'Не удалось получить список оптик.');
  }
};

// Загрузка подземок по округу
export const SearchSubwaysCanton = async (canton, setOptics, setError) => {

  try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${GET_STATISTICS_SUBWAY_CANTON_API_URL}?canton=${canton}`, {
          headers: {
              'Authorization': `Bearer ${token}`
          }
      });
     const { result, houses } = response.data;
      setOptics(result);

      setError('');
  } catch (error) {
      setError(error.response?.data.message || 'Не удалось получить список подземок!');
  }
};

// Загрузка подземок по городу
export const SearchSubwaysCity = async (city, setOptics, setError) => {

  try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${GET_STATISTICS_SUBWAY_CITY_API_URL}?city=${city}`, {
          headers: {
              'Authorization': `Bearer ${token}`
          }
      });
     const { result, houses } = response.data;
      setOptics(result);

      setError('');
  } catch (error) {
      setError(error.response?.data.message || 'Не удалось получить список подземок!');
  }
};

// // Внесение дома ручная актуализация териттории
// export const SearchHouseAddress = async (hid, setHouse) => {
//   try {
//       const token = localStorage.getItem('token');
//       const response = await axios.get(`${GET_HOUSE_API_URL}?hid=${hid}`, {
//           headers: {
//               'Authorization': `Bearer ${token}`
//           }
//       });

//       setHouse(response.data);
     
//   } catch (error) {
//      console.log("Ошибка! Дом не найден.");
//   }
// };


// // Загрузка номеров узлов 
// export async function fetchNodeData() {
//   try {
//     const token = localStorage.getItem('token');
//     const resultNode = await axios.get(GET_NUMBER_NODE_API_URL,{
//       headers:{
//         'Authorization': `Bearer ${token}` 
//       }
//     });
//     return resultNode.data;
//   } catch (error) {
//    // console.error("Error fetching data:", error);
//     return null;
//   }
// }

// export async function loadingNumberNode(setNode) {
//   const nodeData = await fetchNodeData();
//   if (nodeData) {
//     setNode(nodeData);
//   }
// }








 